























import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Big from 'big.js'

@Component({
    components: {},
})
export default class DCMBalanceTableSummary extends Vue {
    balances: any[] = [
        {
            name: 'Locked',
            balance: this.totalDCMLocked,
        },
        {
            name: 'Unlocked',
            balance: this.totalDCMUnlocked,
        },
        {
            name: 'Staked',
            balance: this.totalDCMStaked,
        },
        {
            name: 'Total Balance',
            balance: this.totalDCM,
        },
    ]

    @Prop() pUnlocked!: Big
    @Prop() pLockedStakeable!: Big
    @Prop() pLockedNotStakeable!: Big
    @Prop() pStaked!: Big
    @Prop() xpUnlocked!: Big
    @Prop() xUnlocked!: Big
    @Prop() xLocked!: Big
    @Prop() xcUnlocked!: Big

    get totalDCMStaked(): Big {
        return this.pStaked
    }

    get totalDCMLocked(): Big {
        return this.pLockedStakeable
            .plus(this.pLockedNotStakeable)
            .plus(this.xLocked)
    }

    get totalDCMUnlocked(): Big {
        return this.pUnlocked
            .plus(this.xpUnlocked)
            .plus(this.xUnlocked)
            .plus(this.xcUnlocked)
    }

    get totalDCM(): Big {
        return this.pUnlocked
            .plus(this.pLockedStakeable)
            .plus(this.pLockedNotStakeable)
            .plus(this.pStaked)
            .plus(this.xpUnlocked)
            .plus(this.xUnlocked)
            .plus(this.xLocked)
            .plus(this.xcUnlocked)
    }
}
